<template>
	<div class="h-full overflow-y-scroll">
		<div class="flex flex-row justify-between items-center pt-4">
			<h3 class="text-2xl font-bold  px-4">      		
				Inbox
			</h3>
		</div>
		<div v-if="pedidos && pedidos.length > 0" class="pb-4"> 
			<inbox class="mt-4" :user=" 'admin'" :ordenes="pedidos" :fields="{cliente: true, evidencia: true, surtir: true, aprobar: false, facturar: false, entregar: true}"></inbox>
		</div>
	</div>
</template>

<script>
	import { supabase } from "../supabase.js"
	import { onMounted, ref, watch } from "vue"
	import { utils } from './utils/utils.js'
	import { store } from '../store.js'

	export default {
		name: 'Admin Home',
		setup() {			
			const pedidos = ref([])

			async function getIds() {
				let { data, error } = await supabase.rpc('pedidos_pendientes')

				if (data) {              
					return data
				} else if (error) { 
					alert(error)     
				}   
			}

			async function getPedidos() {
				const ids = await getIds()
				return utils.getAdminPedidos({
					scope: 'inbox',
					pedido_ids: ids || []
				})
			}

			async function loadPedidos() {
				try {
					const data = await getPedidos()
					pedidos.value = data.filter( pedido => {
						return !(pedido.require_aprobacion && !pedido.aprobado)
					})
				} catch (error) {
					if (error.status !== 401) alert(error.message)
				}
			}

			onMounted(() => {
				if (store.authAdmin) loadPedidos()
			})

			watch(() => store.authAdmin, (authorized) => {
				if (authorized) loadPedidos()
			})

			return {      
				pedidos
			}
		}
	}
</script>
